/**
 *
 * Asynchronously loads the component for TrackAssets
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TrackAssets = lazyLoad(
  () => import('./index'),
  module => module.TrackAssets,
);
